import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { I18n } from '../../_ui-core_/base/package/services/package/i18n/i18n.de';
import { paintTick } from '../../_ui-core_/base/package/util/render';
import App from '../../app';
import style from './maintenance-page.css?inline';
import '../../_ui-core_/components/icons/ui-settings-icon';

const CName = 'maintenance-page';

@customElement(CName)
export class MaintenancePage extends LitElement {
  static readonly styles = [unsafeCSS(style)];
  @property() content: string;

  private readonly _onReloadClick = () => {
    App.instance.router.navigateToHome();
    paintTick().then(() => App.instance.router.reloadPage());
  };

  connectedCallback() {
    super.connectedCallback();
    window.$app.track.maintenancePG('shown');
  }

  render() {
    return html`
      <div class="overlay"></div>
      <main>
        <div class="logo"></div>
        <div class="content">
          <div class="icon">
            <ui-settings-icon></ui-settings-icon>
          </div>
          <h2 class="title">${window.$app.$t.get(I18n.maintenance.title)}</h2>
          <p class="subtitle">${window.$app.$t.get(I18n.maintenance.subtitle)}</p>
          <ui-btn variant="secondary" class="refresh-button" @click=${this._onReloadClick}>
            ${window.$app.$t.get(I18n.maintenance.reloadButton)}
          </ui-btn>
        </div>
      </main>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: MaintenancePage;
  }
}
